export default "__VITE_ASSET__CZekmY4r__"